<tab-header [workPackage]="workPackage"></tab-header>
<tab-mrs [workPackage]="workPackage"></tab-mrs>
